const shaka = require("shaka-player");
const mpdParser = require("mpd-parser");

let vendor;

export default class CustomLoader {
  constructor(pVendor) {
    this._vendor = vendor = pVendor;

    shaka.net.NetworkingEngine.registerScheme(
      "http",
      this._defaultScheme,
      shaka.net.NetworkingEngine.PluginPriority.PREFERRED
    );
    shaka.net.NetworkingEngine.registerScheme(
      "https",
      this._defaultScheme,
      shaka.net.NetworkingEngine.PluginPriority.PREFERRED
    );
  }

  _defaultScheme(uri, request) {
    let xhr;
    let promise = new Promise(function(resolve, reject) {
      xhr = new XMLHttpRequest();

      xhr.open(request.method, uri, true);
      xhr.responseType = "arraybuffer";
      xhr.timeout = request.retryParameters.timeout;
      xhr.withCredentials = request.allowCrossSiteCredentials;
      xhr.onload = event => {
        let target = event.target;

        let headers = target
          .getAllResponseHeaders()
          .split("\r\n")
          .reduce(function(all, part) {
            let header = part.split(": ");
            all[header[0].toLowerCase()] = header.slice(1).join(": ");
            return all;
          }, {});
        if (
          target.status >= 200 &&
          target.status <= 299 &&
          target.status !== 202
        ) {
          // Most 2xx HTTP codes are success cases.
          if (target.responseURL) {
            uri = target.responseURL;
          }
          /** @type {shakaExtern.Response}
           *
           */

          let encodedFile = target.response;

          if (
            uri.indexOf("manifest.mpd") > 0 &&
            uri.indexOf("drm-ls.megogo.net") === -1
          ) {
            try {
              let dataView = new DataView(target.response);
              let decoder = new TextDecoder("utf-8");
              let manifest = decoder.decode(dataView);
              // TODO: mpdParser crash if live dynamic playlist. Need fix later
              if (manifest.indexOf('type="dynamic"') === -1) {
                // shaka cut off audio id after 'x' letter
                // so modify 'lang' attribute from 'ru-x-11' to 'ru-11'
                // encode modified manifest to arraybuffer and get it to shaka
                manifest = manifest.replace(
                  /lang="(\w+)-x-(\d+)"/g,
                  'lang="$1-$2"'
                );
                const encoder = new TextEncoder("utf-8");
                encodedFile = encoder.encode(manifest).buffer;

                let parsedManifest = mpdParser.parse(manifest, uri);
                if (vendor && vendor.onManifestPlayList)
                  vendor.onManifestPlayList(parsedManifest);
              }
            } catch (e) {}
          }

          const response = {
            uri: uri,
            data: encodedFile,
            headers: headers,
            fromCache: !!headers["x-shaka-from-cache"]
          };

          resolve(response);
        } else {
          let responseText = null;
          try {
            responseText = shaka.util.StringUtils.fromBytesAutoDetect(
              target.response
            );
          } catch (exception) {}

          let severity =
            target.status === 401 || target.status === 403
              ? shaka.util.Error.Severity.CRITICAL
              : shaka.util.Error.Severity.RECOVERABLE;
          reject(
            new shaka.util.Error(
              severity,
              shaka.util.Error.Category.NETWORK,
              shaka.util.Error.Code.BAD_HTTP_STATUS,
              uri,
              target.status,
              responseText,
              headers
            )
          );
        }
      };
      xhr.onerror = event => {
        reject(
          new shaka.util.Error(
            shaka.util.Error.Severity.RECOVERABLE,
            shaka.util.Error.Category.NETWORK,
            shaka.util.Error.Code.HTTP_ERROR,
            uri
          )
        );
      };
      xhr.ontimeout = event => {
        reject(
          new shaka.util.Error(
            shaka.util.Error.Severity.RECOVERABLE,
            shaka.util.Error.Category.NETWORK,
            shaka.util.Error.Code.TIMEOUT,
            uri
          )
        );
      };
      for (let k in request.headers) {
        xhr.setRequestHeader(k, request.headers[k]);
      }
      xhr.send(request.body);
    });

    return new shaka.util.AbortableOperation(promise, () => {
      if (xhr) {
        xhr.abort();
      }
      return Promise.resolve();
    });
  }
}
